import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FilterService } from '@progress/kendo-angular-grid';
import { ListFilterBaseRow } from './listfilter-base-row';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgClass } from '@angular/common';
import { MultiSelectModule } from '@progress/kendo-angular-dropdowns';

@UntilDestroy()
@Component({
    selector: 'nova-multiselect-filter-row',
    template: ` <kendo-multiselect
        [data]="data"
        [size]="'small'"
        [textField]="textField"
        [valueField]="valueField"
        [valuePrimitive]="true"
        [(value)]="filterModel"
        [allowCustom]="allowCustom"
        [placeholder]="title"
        (valueChange)="onChange($event)"
        [popupSettings]="{ width: 200 }"
        [class.k-chip-list--items]="hasItemsSelected"
        [ngClass]="uniqueFilterClass">
        @if (showIcon) {
            <ng-template
                kendoMultiSelectItemTemplate
                let-dataitem>
                <img
                    [src]="dataitem.src"
                    class="rating-img"
                    [alt]="dataitem.alt" />
                <div>{{ dataitem.name }}</div>
            </ng-template>
        }
    </kendo-multiselect>`,
    styleUrls: ['./multiselect-filter-row.component.scss'],
    standalone: true,
    imports: [NgClass, MultiSelectModule]
})
export class MultiSelectFilterRowComponent extends ListFilterBaseRow implements OnInit, OnChanges {
    @Input() allowCustom: boolean = false;
    @Input() title: string;
    @Input() showIcon: boolean = false;
    @Input() uniqueFilterClass: string;

    hasItemsSelected = false;

    supportsMultipleValues = true;
    public filterModel: any;
    constructor(filterService: FilterService) {
        super(filterService);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.filter) {
            this.updateFilterModel();
        }
    }

    ngOnInit() {
        if (this.filterService && this.filterService.changes) {
            this.filterService.changes.pipe(untilDestroyed(this)).subscribe((val) => this.changeFilter(val));
        }

        if (isEmpty(this.filterModel)) {
            this.updateFilterModel();
        }
    }

    private changeFilter(newFilter: CompositeFilterDescriptor): void {
        if (JSON.stringify(this.filter) !== JSON.stringify(newFilter)) {
            this.filter = newFilter;
            this.updateFilterModel();
        }

        this.hasItemsSelected = this.filterModel.length > 0;
    }

    private updateFilterModel() {
        const stored = this.filterByField(this.field);
        this.filterModel = stored ? [].concat(stored.value) : [];
    }
}
